module.exports = __webpack_public_path__ + "img/Sonnenblume_Feld2.1d807092.jpg";